import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/',               label: 'Dashboard',        exact: true },
  { to: '/clientes',       label: 'Clientes'                      },
  { to: '/notificaciones', label: 'Notificaciones'                },
  { to: '/tiendas',        label: 'Tiendas'                       },
  { to: '/diseno',         label: 'Diseño de passes'              },
  { to: '/niveles',        label: 'Niveles de lealtad'            },
  { to: '/usuarios',       label: 'Equipo'                        },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&family=Barlow:wght@300;400;500&display=swap');
        .sidebar {
          width: 220px;
          background: #111;
          display: flex;
          flex-direction: column;
          position: fixed;
          top: 0; left: 0; bottom: 0;
          z-index: 100;
          font-family: 'Barlow', sans-serif;
        }
        .sidebar-brand {
          padding: 28px 24px 24px;
          border-bottom: 1px solid rgba(255,255,255,0.07);
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .sidebar-square { width: 28px; height: 28px; background: #dc1414; flex-shrink: 0; }
        .sidebar-brand-text {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 18px; font-weight: 700; letter-spacing: 1.5px;
          text-transform: uppercase; color: #fff; line-height: 1;
        }
        .sidebar-brand-sub {
          font-size: 10px; letter-spacing: 2px; text-transform: uppercase;
          color: rgba(255,255,255,0.3); font-weight: 400; margin-top: 2px;
        }
        .sidebar-nav { flex: 1; padding: 20px 0; overflow-y: auto; }
        .sidebar-section {
          font-size: 10px; font-weight: 600; letter-spacing: 2.5px;
          text-transform: uppercase; color: rgba(255,255,255,0.2);
          padding: 16px 24px 8px;
        }
        .sidebar-nav a {
          display: flex; align-items: center;
          padding: 10px 24px; font-size: 13px; font-weight: 400;
          color: rgba(255,255,255,0.45); text-decoration: none;
          letter-spacing: 0.3px; transition: all 0.15s;
          border-left: 2px solid transparent;
        }
        .sidebar-nav a:hover { color: #fff; background: rgba(255,255,255,0.05); }
        .sidebar-nav a.active {
          color: #fff; font-weight: 500;
          border-left-color: #dc1414;
          background: rgba(255,255,255,0.07);
        }
        .sidebar-footer {
          padding: 20px 24px;
          border-top: 1px solid rgba(255,255,255,0.07);
        }
        .sidebar-user { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
        .sidebar-avatar {
          width: 32px; height: 32px; background: #dc1414; color: #fff;
          display: flex; align-items: center; justify-content: center;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 14px; font-weight: 700; flex-shrink: 0;
        }
        .sidebar-user-name {
          font-size: 13px; font-weight: 500; color: #fff;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }
        .sidebar-user-role {
          font-size: 11px; color: rgba(255,255,255,0.35);
          text-transform: capitalize; letter-spacing: 0.5px;
        }
        .sidebar-logout {
          width: 100%; padding: 9px;
          background: rgba(255,255,255,0.07); border: none;
          font-family: 'Barlow', sans-serif; font-size: 12px; font-weight: 500;
          letter-spacing: 1.5px; text-transform: uppercase;
          color: rgba(255,255,255,0.4); cursor: pointer; transition: all 0.15s;
        }
        .sidebar-logout:hover { background: #dc1414; color: #fff; }
      `}</style>
      <aside className="sidebar">
        <div className="sidebar-brand">
          <div className="sidebar-square" />
          <div>
            <div className="sidebar-brand-text">2CAP</div>
            <div className="sidebar-brand-sub">Admin</div>
          </div>
        </div>
        <nav className="sidebar-nav">
          <div className="sidebar-section">Gestión</div>
          {navItems.map(({ to, label, exact }) => (
            <NavLink key={to} to={to} end={exact}
              className={({ isActive }) => isActive ? 'active' : ''}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-avatar">{user?.name?.[0] || 'A'}</div>
            <div>
              <div className="sidebar-user-name">{user?.name || 'Admin'}</div>
              <div className="sidebar-user-role">{user?.role || 'admin'}</div>
            </div>
          </div>
          <button className="sidebar-logout" onClick={handleLogout}>Cerrar sesión</button>
        </div>
      </aside>
    </>
  );
}
